import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MaintenanceHistory from '../components/MaintenanceHistory';
import API_URL from "../api/baseURL";

const MaintenanceHistoryWrapper = () => {
  const { vehicleId } = useParams();
  const { token } = useAuth();

  return <MaintenanceHistory vehicleId={vehicleId} token={token} />;
};

export default MaintenanceHistoryWrapper;
